import React, { useEffect, useState } from "react";
import axios from "axios";
import { MyPieChart } from "../pieChart";
import "../../dashboardStyle/dashStock.css";
import HelpIcon from '@mui/icons-material/Help';


import { Dialog } from 'primereact/dialog';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { TabView, TabPanel } from 'primereact/tabview';



import mapPlaceBox from "../../../mapPlaceBox";

export const DashStkTout = ({ dim }) => {
    const [visible, setVisible] = useState(false);

    const apiUrl = process.env.REACT_APP_API_URL;
    const [totalStockages, setTotalStockages] = useState(0);
    const [stockagesOccupes, setStockagesOccupes] = useState(0);
    const [stockagesLibres, setStockagesLibres] = useState(0);
    const [error, setError] = useState(null);

    const [infosLibres, setInfosLibres] = useState([]);
    const [infosOccupes, setInfosOccupes] = useState([]);


 useEffect(() => {
   axios
     .get(`${apiUrl}/IHM/api/infoDashboard.php?Libres=TOUS`)
     .then((response) => {
       setInfosLibres(response.data);
     })
     .catch((error) => {
       console.error(
         "Erreur lors du chargement des fiches abandonnées :",
         error
       );
     });
 }, []);

 useEffect(() => {
   axios
     .get(`${apiUrl}/IHM/api/infoDashboard.php?Occupes=TOUS`)
     .then((response) => {
       setInfosOccupes(response.data);
     })
     .catch((error) => {
       console.error(
         "Erreur lors du chargement des fiches abandonnées :",
         error
       );
     });
 }, []);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(`${apiUrl}IHM/api/dashboard.php?box=tout`);
        if (response.data && response.data.totalStockages !== undefined) {
          setTotalStockages(response.data.totalStockages);
          setStockagesOccupes(response.data.stockagesOccupes);
          setStockagesLibres(response.data.stockagesLibres);
        } else {
          console.error("La réponse de l'API n'est pas valide:", response.data);
          setError("Les données reçues ne sont pas valides.");
        }
      } catch (error) {
        console.error("Erreur lors de la récupération des données:", error);
        setError("Erreur lors de la récupération des données.");
      }
    };

    fetchData();
  }, [apiUrl]);

  if (error) {
    return <div>{error}</div>;
  }






  return (
    <>
      <Dialog
        header="Tous les stockages"
        visible={visible}
        style={{ width: "70vw" }}
        onHide={() => {
          if (!visible) return;
          setVisible(false);
        }}
      >
        <TabView>
          <TabPanel header="Libres">
            <DataTable
              value={infosLibres}
              paginator
              rows={10}
              rowsPerPageOptions={[5, 10, 25, 50]}
              size="small"
              paginatorRight={
                <span style={{ margin: "10px", fontWeight: "bold" }}>
                  Résultats : {infosLibres.length}
                </span>
              }
              paginatorTemplate={
                "FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
              }
            >
              <Column header="N°" field="idStockage" />

              <Column header="Volume (m³)" field="vol" />

              <Column
                header="Place"
                field="place"
                body={(rowData) => (
                  <div>
                    <span>{mapPlaceBox(rowData.place)}</span>
                  </div>
                )}
              />
            </DataTable>
          </TabPanel>

          <TabPanel header="Occupés">
            <DataTable
              value={infosOccupes}
              paginator
              rows={10}
              rowsPerPageOptions={[5, 10, 25, 50]}
              size="small"
              paginatorRight={
                <span style={{ margin: "10px", fontWeight: "bold" }}>
                  Résultats : {infosOccupes.length}
                </span>
              }
              paginatorTemplate={
                "FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
              }
            >
              <Column header="N°" field="idStockage" />

              <Column header=" Volume (m³)" field="vol" />

              <Column header="Client" field="nom" />

              <Column
                header="Place"
                field="place"
                body={(rowData) => (
                  <div>
                    <span>{mapPlaceBox(rowData.place)}</span>
                  </div>
                )}
              />
            </DataTable>
          </TabPanel>
        </TabView>
      </Dialog>

      <div
        style={{
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          style={{
            fontWeight: "600",
            fontSize: "18px",
            marginBottom: "10px",
          }}
        >
          <span
            style={{ fontWeight: "600", cursor: "pointer", zIndex: "22" }}
            onClick={() => setVisible(true)}
          >
            Tous les stockages <HelpIcon sx={{ fontSize: 14 }} />
          </span>
        </div>
        <MyPieChart data={[stockagesOccupes, stockagesLibres]} dim={dim} />
      </div>
    </>
  );
};